import script from "./SigningDocumentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SigningDocumentModal.vue?vue&type=script&setup=true&lang=js"

import "./SigningDocumentModal.vue?vue&type=style&index=0&id=ceef0684&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceef0684"]])

export default __exports__